const Error = () => {
    return (
        <div className="vh-100 w-100 d-flex justify-content-center align-items-center">
            <h1 className="text-danger alert alert-danger">Page Not Found !</h1>
        </div>
    );
}

export default Error;